declare module 'pixi.js' {
  interface DisplayObject {
    /**
     * Wether object is destroyed
     */
    destroyed: boolean;

    /**
     * Callbacks that executes before destroy
     */
    ecBeforeDestroyCallbacks: (() => void)[];

    /**
     * Update
     * @param dt Delta time
     */
    ecUpdate(dt: number): void;
  }
}

import { DisplayObject } from 'pixi.js';

DisplayObject.prototype.ecUpdate = (_: number) => {};

const destroy = DisplayObject.prototype.destroy;
DisplayObject.prototype.destroy = function (): void {
  for (const callback of this.ecBeforeDestroyCallbacks) {
    callback();
  }
  destroy.call(this);
};

Object.defineProperty(DisplayObject.prototype, 'destroyed', {
  get(): void {
    return this._destroyed;
  },
  enumerable: true
});

Object.defineProperty(DisplayObject.prototype, 'ecBeforeDestroyCallbacks', {
  get(): void {
    if (this._ecBeforeDestroyCallbacks === undefined) {
      this._ecBeforeDestroyCallbacks = [];
    }
    return this._ecBeforeDestroyCallbacks;
  },
  enumerable: true
});
